import type { ReactNode } from 'react'

export interface PillOption<V extends string> {
  value: V
  label: ReactNode
}

export interface SegmentedPillsProps<V extends string> {
  options: PillOption<V>[]
  value: V
  onChange: (value: V) => void
  label: string
}

/** Pattern « segmented pills » (période, statut, format) — radio group accessible. */
export function SegmentedPills<V extends string>({
  options,
  value,
  onChange,
  label,
}: SegmentedPillsProps<V>) {
  return (
    <div className="pills" role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          className="pill"
          aria-checked={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
